/**
 * The route client code reads bearers from (see
 * pages/api/auth/access-token.ts). It serves the session ffh-backend issued
 * us, in the `{token}` shape the SDK's own endpoint used to return.
 */
export const ACCESS_TOKEN_ROUTE = '/api/auth/access-token';
